import $ from "jquery";

$(function () {
  let teamOrder = [];
  let currentTeamIndex = 0;

  $("body").on("click", ".js-team-modal", function (e) {
    e.preventDefault();

    // Collect all team member IDs and remove duplicates
    teamOrder = [];
    let seenIds = new Set();
    $(".js-team-modal:visible").each(function () {
      let memberId = $(this).data("member-id");
      if (!seenIds.has(memberId)) {
        seenIds.add(memberId);
        teamOrder.push(memberId);
      }
    });

    currentTeamIndex = teamOrder.indexOf($(this).data("member-id"));

    loadTeamModal(teamOrder[currentTeamIndex]);
  });

  function loadTeamModal(teamId) {
    var $modal = $(".modal-team");
    $("body").addClass("modal-active");
    $modal.removeClass("hidden").addClass("flex items-center justify-center");
    setTimeout(() => $modal.removeClass("opacity-0"), 10);

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: {
        action: "modal_team",
        id: teamId,
      },
      success: function (res) {
        if (res.success) {
          $modal.find(".modal-team__block").html(res.data.html);
          updatePrevNextButtons();
        }
      },
      error: function () {
        $modal
          .find(".modal-team__block")
          .html(
            '<div class="p-8 text-center text-red">Error loading team info.</div>'
          );
      },
    });
  }

  function updatePrevNextButtons() {
    $(".modal-team__prev").prop("disabled", currentTeamIndex <= 0);
    $(".modal-team__next").prop(
      "disabled",
      currentTeamIndex >= teamOrder.length - 1
    );
  }

  function closeModal() {
    var $modal = $(".modal-team");
    $modal.addClass("opacity-0");
    setTimeout(() => {
      $modal.addClass("hidden");
      $modal.find(".modal-team__block").html("");
      $("body").removeClass("modal-active");
    }, 300);
  }

  $("body").on("click", ".modal-team__prev", function (e) {
    e.preventDefault();
    if (currentTeamIndex > 0) {
      currentTeamIndex--;
      loadTeamModal(teamOrder[currentTeamIndex]);
    }
  });

  $("body").on("click", ".modal-team__next", function (e) {
    e.preventDefault();
    if (currentTeamIndex < teamOrder.length - 1) {
      currentTeamIndex++;
      loadTeamModal(teamOrder[currentTeamIndex]);
    }
  });

  $("body").on("click", ".modal-team__close", function (e) {
    e.preventDefault();
    closeModal();
  });

  $("body").on("click", ".modal-team", function (e) {
    if (e.target === this) {
      closeModal();
    }
  });
});
